<sftp-admin-gui *ngIf="!error; else errorPage">
  <p-toast></p-toast>
  <app-header></app-header>
  <div style="padding: 20px">
  <router-outlet></router-outlet></div>
  <app-footer></app-footer>
</sftp-admin-gui>
<ng-template #errorPage>
  <app-error-handler [error]="error"></app-error-handler>
</ng-template>
